import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loss-support-doc',
    templateUrl: './loss-support-doc.component.html',
    styleUrls: ['./loss-support-doc.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LossSupportDocComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
